import {
  TCreativeFormOptions,
  TCreativeMultipleFields,
  ECreativeFormFields,
  TCreativeMultipleField,
  TDropDownListWithType,
  TCropConfig,
  TCropCoordinate,
} from '@/types';
import { getTranslate } from '@/helpers/translateHelpers';
import { ICreative, ICreativeStatistics } from '@/types/campaign/creatives';

export const STORE_PATH = 'campaignCreatives';
export const MODERATION_EXPAND =
  'ssp_moderate,ssp_moderate.moderator,ssp_moderate.creative_moderation';
export const MODERATION_FIELDS = 'id';
export const CREATIVE_FIELDS = [
  'id',
  'ctr',
  'cpc',
  'count_lead',
  'count_view',
  'sum_revenue',
  'count_click',
];
export const PREFIX_ID = 'new-';
export const DEFAULT_ASPECT_RATIO = 1;

export const REQIRED_FIELDS: Array<string> = [
  ECreativeFormFields.url,
  ECreativeFormFields.title,
  ECreativeFormFields.description,
];

export const getCreativeInit = (): ICreative => {
  return {
    id: '',
    url: '',
    title: '',
    description: '',
    cta: '',
    status: {
      label: getTranslate('body.topBar.status.active'),
      value: 'active',
    },
    campaignId: null,
    fileId: null,
    img: '',
    sourceImg: null,
    width: null,
    height: null,
    file: null,
    sspModerate: [],
    statistics: {} as ICreativeStatistics,
    template: null,
    position: null,
    coordinates: [],
    errors: {
      url: [],
      img: [],
      title: [],
      description: [],
      cta: [],
    },
  };
};

export const getCreativeFormOptions = (): TCreativeFormOptions => {
  return {
    trafficType: null,
    maxSymbols: {
      [ECreativeFormFields.title]: 65,
      [ECreativeFormFields.description]: 120,
      [ECreativeFormFields.cta]: 30,
    },
  };
};

export const getMultipleFieldInit = (): TCreativeMultipleField => {
  return {
    value: '',
    errors: [],
  };
};

export const getMultipleFieldsInit = (): TCreativeMultipleFields => {
  return {
    [ECreativeFormFields.title]: [],
    [ECreativeFormFields.description]: [],
    [ECreativeFormFields.cta]: [],
  };
};

export const getCropConfig = (): TCropConfig => {
  return {
    defaultWidth: 900,
    scale: 2,
    zoomSpeed: 5,
    imageFormat: 'image/png',
  };
};

export const getCropAspectRatio = (): TDropDownListWithType<string> => {
  return [
    {
      label: '1:1',
      value: '1:1',
    },
    {
      label: '1.91:1',
      value: '1.91:1',
    },
    {
      label: '16:9',
      value: '16:9',
    },
    {
      label: '3:2',
      value: '3:2',
    },
    {
      label: '4:3',
      value: '4:3',
    },
    {
      label: '8:5',
      value: '8:5',
    },
  ];
};

export const getCropCoordinates = (): TCropCoordinate => {
  return {
    aspect_ratio: '',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  };
};
